import React, { useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import Flex from '@wix/da-ds/pkg/Flex';
import FlexItem from '@wix/da-ds/pkg/Flex/Item';
import ExclusiveButton from '@wix/da-ds/pkg/Buttons/ExclusiveButton';
import { IconSize } from '@wix/da-ds/pkg/Icons/IconWrap';
import GiftAnimated from '@wix/da-ds/pkg/Icons/GiftAnimated';
import { BiData, BiContextProvidedValue } from '@wix/da-bi/pkg/events';
import { useBuyNowAction } from '../../hooks';
import GiftExclusivePopup from './_partials/GiftExclusivePopup';
import s from './GiftButton.scss';
const GiftButton = ({ deviation, adoptableState: { fixedPrice = 0 } })=>{
    const { t } = useTranslation();
    const [showGiftExcusivePopup, setShowGiftExclusivePopup] = useState(false);
    const [forUserId, setForUserId] = useState(undefined);
    const sectionname = 'side-rail';
    const [onBuyNow] = useBuyNowAction(deviation, {
        sectionname,
        purchase_price: fixedPrice
    }, forUserId);
    useEffect(()=>{
        if (forUserId) {
            setForUserId(undefined);
            setShowGiftExclusivePopup(false);
            onBuyNow();
        }
    }, [
        forUserId,
        onBuyNow
    ]);
    return /*#__PURE__*/ React.createElement(React.Fragment, null, /*#__PURE__*/ React.createElement(ExclusiveButton, {
        compact: true,
        key: "gift-now",
        priority: "secondary",
        onClick: ()=>setShowGiftExclusivePopup(true),
        biData: BiData({
            evid: 750,
            purchase_price: fixedPrice,
            itemid: deviation.deviationId,
            sectionname: BiContextProvidedValue
        })
    }, /*#__PURE__*/ React.createElement(Flex, {
        gap: 4,
        alignItems: "center",
        className: s['root']
    }, /*#__PURE__*/ React.createElement(FlexItem, null, /*#__PURE__*/ React.createElement(Flex, {
        inline: true,
        alignItems: "center"
    }, /*#__PURE__*/ React.createElement(GiftAnimated, {
        size: IconSize.MEDIUM,
        className: s['gift-icon']
    }))), /*#__PURE__*/ React.createElement(FlexItem, null, t('sidebar.exclusives.buttons.buyer.gift.label')))), showGiftExcusivePopup && /*#__PURE__*/ React.createElement(GiftExclusivePopup, {
        requestClose: ()=>setShowGiftExclusivePopup(false),
        onItemClick: (user)=>setForUserId(user.userId)
    }));
};
GiftButton.displayName = 'GiftButton';
export default GiftButton;
